import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import cookie from "react-cookies";

import { getListAddressOfUser } from "../../model/profile";
import { getAddressFromLatLng, searchInHouse, searchLocations } from "../../model/common";

import { getHereAddress } from "../common/common";
import { mapSdk } from "../../model/base";
import { commonErr } from "./errors";
import { MessageBox } from "./messagebox";
import { LoadingInline } from "./loading";

import { IcLocationSearch, IcSuggestHome, IcSuggestPlane, IcSuggestSearch } from "./svg";

class LocationItem extends Component {
	handlePress = async () => {
		await this.props.selectLocation(this.props.item); // item
	};
	render() {
		const address = getHereAddress(this.props.item.address);
		return (
			<div className="location-item" onClick={this.handlePress}>
				<div className="wrap-svg">
					<IcLocationSearch />
				</div>
				<p>{address}</p>
			</div>
		);
	}
}

const DefaultLocation = (props) => {
	const [address, setAddress] = useState();
	const [errAddress, setErrAddress] = useState(commonErr.LOADING);
	const [airports, setAirports] = useState([]);
	const [errAirports, setErrAirports] = useState(commonErr.LOADING);
	const [histories, setHistories] = useState([]);
	const [errHistories, setErrHistories] = useState(commonErr.LOADING);

	useEffect(() => {
		if (props.session.profile && props.session.profile.info && props.session.profile.info.uid) {
			getListAddressOfUser().then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
					const defaultAddress = resp.data.data.addresses.find((address) => address.isDefault);
					setErrAddress(commonErr.SUCCESS);
					setAddress(defaultAddress);
				}
			});
		} else {
			setErrAddress(commonErr.SUCCESS);
		}

		searchLocations(1).then((resp) => {
			setErrAirports(commonErr.SUCCESS);
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				setAirports(resp.data.data.locations);
			}
		});

		const historiesList = [];
		for (let i = 0; i < 10; i++) {
			//parse string to array ( address | lat | lng )
			const history = cookie.load(`_mhistory${i}`);
			if (history !== undefined) {
				const parseHistory = history.split("|");
				historiesList.unshift({ label: parseHistory[0], lat: parseHistory[1], lon: parseHistory[2] });
			}
		}
		setErrHistories(commonErr.SUCCESS);
		setHistories(historiesList);
	}, []);

	return (
		<>
			<div className="box-container">
				<div className="wrap-box">
					<div className="box-item" onClick={() => props.getCurrentAddress()}>
						<div className="wrap-svg">
							<IcSuggestSearch />
						</div>
						<div className="box-item__text">
							<p className="main">Vị trí hiện tại</p>
						</div>
					</div>
				</div>
			</div>
			{errAddress === commonErr.LOADING ? (
				<div className="box-container marginTop-m">
					<LoadingInline />
				</div>
			) : (
				<>
					{address && (
						<div className="box-container">
							<p className="title-box">Địa chỉ của tôi</p>
							<div className="wrap-box">
								<div className="box-item" onClick={() => props.selectLocation(address, 1)}>
									<div className="wrap-svg">
										<IcSuggestHome />
									</div>
									<div className="box-item__text">
										<p className="main">{address.addressName}</p>
										<p>
											{address.street}, {address.wardName}, {address.districtName}, {address.cityName}
										</p>
									</div>
								</div>
							</div>
						</div>
					)}
				</>
			)}
			{errAirports === commonErr.LOADING ? (
				<div className="box-container marginTop-m">
					<LoadingInline />
				</div>
			) : (
				<>
					{airports.length > 0 && (
						<div className="box-container">
							<p className="title-box">Giao xe sân bay</p>
							<div className="wrap-box airport">
								{airports.map((airport) => (
									<div className="box-item" key={airport.id} onClick={() => props.selectLocation(airport, 2)}>
										<div className="wrap-svg">
											<IcSuggestPlane />
										</div>
										<div className="box-item__text">
											<p className="main">{airport.name}</p>
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</>
			)}
			{errHistories === commonErr.LOADING ? (
				<div className="box-container marginTop-m">
					<LoadingInline />
				</div>
			) : (
				<>
					{histories.length > 0 && (
						<div className="box-container">
							<p className="title-box">Tìm kiếm gần đây</p>
							<div className="wrap-box">
								{histories.map((his) => (
									<div key={his.label} className="box-item" onClick={() => props.selectLocation(his)}>
										<div className="wrap-svg">
											<IcSuggestSearch />
										</div>
										<div className="box-item__text">
											<p className="main">{his.label}</p>
											{/* <p>Đường Vo Van Tan, phường Vo Thi Sau, quận 3, thành phố Hồ Chí Minh</p> */}
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
};

class HereAutoComplete extends Component {
	constructor(props) {
		super(props);

		// const address = this.getEmptyAddress();
		this.state = {
			address: "",
			query: "",
			locationId: "",
			locationResults: [],
			isShowAddressBox: false,
			currentPosFailed: false,
		};

		this.historyAddress = [];
		this.wrapAutoSuggest = React.createRef();
	}

	componentDidMount() {
		//Load History Addresses
		for (let i = 0; i < 10; i++) {
			const history = cookie.load(`_mhistory${i}`);
			if (history !== undefined) {
				this.historyAddress.push(history);
			}
		}

		if (this.props.inputProps) {
			this.setState({
				query: this.props.inputProps.value,
			});
		}
		document.addEventListener("click", this.handleClick);
	}

	componentDidUpdate(preProps) {
		if (preProps.inputProps.value !== this.props.inputProps.value) {
			this.setState({
				query: this.props.inputProps.value,
			});
		}
	}

	UNSAFE_componentWillUnmount() {
		// important
		document.removeEventListener("click", this.handleClick);
	}

	handleClick = (e) => {
		if (this.wrapAutoSuggest.current && e.target !== null) {
			this.setState({
				query: "",
				isShowAddressBox: false,
			});
		}
	};

	onFocus = (evt) => {
		evt.target.select();
	};

	onQuery = (evt) => {
		const query = evt.target.value;
		let lat, lng;

		if (this.props.focusAddress) {
			lat = this.props.carFinding.filter.lat;
			lng = this.props.carFinding.filter.lng;
		} else if (this.props.locAddress) {
			// get from carDetail && locationDelivery
			lat = this.props.locAddress.lat;
			lng = this.props.locAddress.lng;
		}

		this.setState({
			query: query,
		});

		if (this.timeout) clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			if (query.length >= 3) {
				searchInHouse(query, lat, lng).then((response) => {
					if (response && response.data && response.data.data && response.data.data.locations) {
						var ret = [];

						for (var i = 0; i < response.data.data.locations.length; i++) {
							var location = response.data.data.locations[i];
							var data = {
								id: location.subId,
								address: location.address,
								label: location.address,
								lat: location.lat,
								lon: location.lon,
							};
							ret.push(data);
						}
						this.setState({
							locationResults: ret,
							isShowAddressBox: true,
						});
					}
				});
			}
		}, 500);
	};

	saveHistoryAddressCookie = (strHistoryAddress) => {
		if (this.historyAddress.includes(strHistoryAddress)) {
			const lastHistoryAddress = this.historyAddress.splice(this.historyAddress.indexOf(strHistoryAddress), 1);
			this.historyAddress = this.historyAddress.concat(lastHistoryAddress);
			for (let i = 0; i < this.historyAddress.length; i++) {
				cookie.remove(`_mhistory${i}`, { path: "/" });
				cookie.save(`_mhistory${i}`, this.historyAddress[i], { path: "/" });
			}
		} else {
			this.historyAddress.push(strHistoryAddress);
			for (let i = 0; i < this.historyAddress.length; i++) {
				cookie.remove(`_mhistory${i}`, { path: "/" });
				cookie.save(`_mhistory${i}`, this.historyAddress[i], { path: "/" });
			}
		}
	};

	onSelectLocation = (location, type) => {
		this.setState({
			isShowAddressBox: false,
		});

		//type
		// 0: address from search & history & current position --- DEFAULT
		// 1: address from my address list
		// 2: address from airport list
		const addressQuery =
			type === 1
				? `${location.street}, ${location.wardName}, ${location.districtName}, ${location.cityName}`
				: type === 2
				? location.name
				: location.label;

		if (location && location.lat && location.lon) {
			let address = {
				address: addressQuery,
				lat: location.lat,
				lng: location.lon,
			};
			this.props.onSelect(address);
			this.setState({
				query: addressQuery,
			});

			//save history address when search is done (not saved airport address)
			if (type !== 2) {
				const strHistoryAddress = `${addressQuery}|${location.lat}|${location.lon}`;
				this.saveHistoryAddressCookie(strHistoryAddress);
			}
		} else {
			axios
				.get("https://geocoder.ls.hereapi.com/6.2/geocode.json", {
					params: {
						apiKey: "xbdotv2bSiK72Tq4E5hwyhFNyn_l4T99Rqzotv69rjc",
						searchtext: addressQuery,
					},
				})
				.then((response) => {
					const query = response.data.Response.View[0].Result[0].Location.Address.Label;
					const loc = response.data.Response.View[0].Result[0].Location.DisplayPosition;

					let address = { address: query, lat: loc.Latitude, lng: loc.Longitude };
					this.props.onSelect(address);

					this.setState({
						query: query,
					});

					//save history address when search is done (not saved airport address)
					if (type !== 2) {
						const strHistoryAddress = `${query}|${loc.Latitude}|${loc.Longitude}`;
						this.saveHistoryAddressCookie(strHistoryAddress);
					}
				});
		}
	};

	handleShowAddressBox = (e) => {
		e.stopPropagation();
		this.setState({
			isShowAddressBox: true,
			locationResults: [],
		});
	};

	getCurrentAddress = async () => {
		const options = {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0,
		};

		const handleSuccess = async (pos) => {
			const { latitude, longitude } = pos.coords;
			const result = await getAddressFromLatLng(latitude, longitude);
			const addressCurrent = result.data.result ? result.data.result[0].address : "Vị trí của tôi";

			const address = {
				label: addressCurrent,
				lat: latitude,
				lon: longitude,
			};
			this.onSelectLocation(address);
		};

		const handleError = () => {
			this.setState({
				currentPosFailed: true,
			});
		};

		navigator.geolocation.getCurrentPosition(handleSuccess, handleError, options);
	};

	hideBoxCurrentPosFailed = () => {
		this.setState({
			currentPosFailed: false,
		});
	};

	render() {
		const { query, locationResults, isShowAddressBox, currentPosFailed } = this.state;
		const { inputProps, theme, hidden, suggest, session } = this.props;

		return (
			<div className="here-autocomplete">
				{/* onFocus={(e) => inputProps.onFocus(e)} */}
				{inputProps && inputProps.placeholder ? (
					<input
						onClick={suggest && this.handleShowAddressBox}
						type="text"
						disabled={hidden !== undefined && hidden}
						onFocus={(e) => inputProps.onFocus(e)}
						value={query}
						placeholder={inputProps.placeholder}
						onChange={(e) => this.onQuery(e)}
					/>
				) : (
					<input
						onClick={suggest && this.handleShowAddressBox}
						type="text"
						value={query}
						placeholder="Nhập địa điểm cụ thể"
						onFocus={(e) => inputProps.onFocus(e)}
						onChange={(e) => this.onQuery(e)}
					/>
				)}
				{isShowAddressBox && (
					<div className={`autocomplt-box`} ref={this.wrapAutoSuggest}>
						{locationResults.length === 0 && suggest ? (
							<DefaultLocation
								session={session}
								selectLocation={this.onSelectLocation}
								getCurrentAddress={this.getCurrentAddress}
							/>
						) : (
							<>
								{locationResults.map((item, id) => (
									<LocationItem
										key={id}
										item={item}
										selectLocation={this.onSelectLocation}
										isShowAddressBox={isShowAddressBox}
									/>
								))}
							</>
						)}
					</div>
				)}
				<MessageBox
					show={currentPosFailed}
					hideModal={this.hideBoxCurrentPosFailed}
					message={`Vui lòng cấp quyền truy cập định vị cho trang web để tối ưu tìm kiếm.`}
				/>
			</div>
		);
	}
}

function mapState(state) {
	return {
		carFinding: state.carFinding,
		session: state.session,
	};
}

HereAutoComplete = connect(mapState)(HereAutoComplete);

export default HereAutoComplete;
